const routes = {
  homePage: {
    homePage: "/homePage",
  },
  login: {
    root: "/login",
  },
  punchOrder: {
    punchOrder: "/punchOrder",
  },
  paymentPreference: {
    paymentPreference: "/paymentPreference",
  },
  batchPreference: {
    batchPreference: "/batchPreference",
  },
  editPayments: {
    editPayments: "/editPayments",
  },
  customerOrders: {
    customerOrders: "/customerOrders",
  },
  pageNotFound: {
    pageNotFound: "/pageNotFound",
  },
  editPaymentFlowType: {
    editPaymentFlowType: "/editPaymentFlowType",
  },
};

export default routes;
